export default __webpack_public_path__ + "assets/images/2169f822304f64b64d5cf42dfbc0d00e.png";